/** @griffel:css-start [d] null **/
.f11khh7q{block-size:24px;}
.f1ewtqcl{box-sizing:border-box;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f44lkw9{border-radius:var(--borderRadiusCircular);}
.f1ifyi5{padding-inline:10px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1ufnopg{column-gap:var(--spacingHorizontalXS);}
.f1ugzwwg{font-size:12px;}
.f104wqfl{line-height:16px;}
.fdj6btp{font-weight:var(--fontWeightMedium);}
.fz5stix{white-space:nowrap;}
.fghlq4f{border-top-color:var(--colorTransparentStroke);}
.fb073pr{border-bottom-color:var(--colorTransparentStroke);}
.f1u9dzx2{border-inline-start-color:var(--colorTransparentStroke);}
.f19bg87z{border-inline-end-color:var(--colorTransparentStroke);}
.f1wl9k8s::before{content:"";}
.fd1hv5k::before{display:inline-block;}
.f1s9zyos::before{flex-shrink:0;}
.fnny5tc::before{inline-size:6px;}
.f1dzc99s::before{block-size:6px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1h23yni::before{border-radius:2px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f3e8jtw::before{background-color:currentColor;}
.f8k7hur{background-color:var(--colorPaletteCornflowerBackground2);}
.fqsigj7{color:var(--colorPaletteCornflowerForeground2);}
.fu7oh0l{background-color:var(--colorPaletteDarkOrangeBackground2);}
.fdlvcco{color:var(--colorPaletteDarkOrangeForeground2);}
.f19ut4y6{background-color:var(--colorPaletteForestBackground2);}
.f1gymlvd{color:var(--colorPaletteForestForeground2);}
.f6hvv1p{background-color:var(--colorPaletteTealBackground2);}
.f135dsb4{color:var(--colorPaletteTealForeground2);}
.f3z4w6d{background-color:var(--colorPaletteMarigoldBackground2);}
.f9603vw{color:var(--colorPaletteMarigoldForeground2);}
.ff379vm{background-color:var(--colorPaletteLavenderBackground2);}
.fwctg0i{color:var(--colorPaletteLavenderForeground2);}
.f14wu1f4{background-color:var(--colorPaletteBrownBackground2);}
.ftl572b{color:var(--colorPaletteBrownForeground2);}
.f4xb6j5{background-color:var(--colorPaletteMagentaBackground2);}
.f1f1fwnz{color:var(--colorPaletteMagentaForeground2);}
/** @griffel:css-end **/